<!-- eslint-disable -->
<template>
  <el-container class="main-layout">
    <!-- style="width: 70px;height: 100vh;overflow:visible;position:fixed;z-index: 50;" -->
    <!-- <el-aside style="    margin-left: 80px;">
      <side-menu/>
    </el-aside> -->
    <AppMenu/>
    <el-container style="margin-left: 70px;">
      <el-header class="main-layout__header" height="auto">
        <app-header :title="title"></app-header>
      </el-header>
      <el-main style="overflow: visible">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<!-- eslint-disable -->
<script>
import SideMenu from '@/components/SideMenu'
import AppMenu from '@/core/components/AppMenu.vue'
import appHeader from '@/components/appHeader'

export default {
  name: 'mainLayout',
  components: {
    SideMenu,
    AppMenu,
    appHeader
  },
  computed: {
    title () {
      return this.$route.meta.title
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  &__header {
    display: flex;
    align-items: center;
    min-height: 60px;
  }
}
</style>
